import React from "react"
import TablePlan from "../../Components/Plans/TablePlan"
import TablePlanCard from "../../Components/Plans/TablePlanCard"
import {Button, Card, Col, Form, Icon, Input, message, Modal, Radio, Row, Spin, Steps, Tooltip, Typography} from "antd"
import {withBreakpoints} from "react-breakpoints"
import {API, Auth} from "aws-amplify"
import {withRouter} from 'react-router-dom'
import '../../Styles/UserPanel/Invoice.css'
import RadioGroup from "antd/lib/radio/group";
import {connect} from "react-redux"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
import {allDispatch as mapDispatchToProps, allState as mapStateToProps} from "../../Redux/Selectors"
import moment from "moment";

const {Paragraph, Title} = Typography;
const {Step} = Steps;

class UpgradePlan extends React.Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.tipoPlan = 'Alta Monotributo'
        this.state = {
            medioPago: 'Tarjeta',
            loading: true,
            costoPlus: 0,
            costoPremium: 0,
            costoAplicaciones: 0,
            costoAplicaionesIIBB: 0,
            user: {},
            paymentResponse: {
                transaction_details: {
                    external_resource_url: 'http://www.google.com'
                }
            },
            currentStep: 0,
            tipoPlan: 'Alta Monotributo',
            trabajaEnAplicacion: false,
            planSelected: '',
            currentKey: 0,
            plans: [],
            subPlans: [],
            payment_data: {
                nombre: '',
                apellido: '',
                dni: null,
                mes: 1,
                año: new Date().getFullYear(),
                codigoSeguridad: 0,
                montoCobro: null,
                medioPago: '',//credit_card, debit_card, ticket
                medioPagoId: '',// visa, master, naranja, diners, etc
                numeroTarjeta: null,
                entidad: "", //rapipago, pagofacil,
            },
            codigo: null,
            loadingCodigo: false,
            codigoValido: null,
            codigoResponse: null
        };
    }

    getAdminLites = () => {
        this.setState({loadingAdminLites: true})
        localStorage.removeItem("adminLiteSelected")
        Auth.currentSession()
            .then(session => {
                API.get(
                    'test',
                    '/root/admindashboard/adminlites/',
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },

                    }
                )
                    .then(response => {
                        this.setState({loadingAdminLites: false, adminLites: response});
                    })
                    .catch(err => {
                        message.error("Error al cargar listado de empresas")
                        this.setState({loadingCodigo: false, codigoValido: false})
                        console.log(err)
                    })
            })

    }

    validarCodigo = () => {
        this.setState({loadingCodigo: true, codigoValido: null, codigoResponse: null})

        Auth.currentSession()
            .then(session => {
                API.get(
                    'test',
                    '/root/admindashboard/code/' + this.state.codigo,
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },

                    }
                )
                    .then(response => {
                        if (response && response[0] && response[0].cuit) {
                            this.setState({loadingCodigo: false, codigoValido: true, codigoResponse: response[0]});
                            this.setState({trabajaEnAplicacion: false});
                            this.props.form.setFieldsValue({trabaja_aplicacion: false});
                        } else {
                            this.setState({loadingCodigo: false, codigoValido: false})
                        }
                    })
                    .catch(err => {
                        this.setState({loadingCodigo: false, codigoValido: false})
                        console.log(err)
                    })
            })
    }

    componentDidMount() {
        let año = new Date().getFullYear()
        let initialStep
        if (this.props.stepsUser) {
            initialStep = this.props.initialStep
        } else {
            initialStep = 2
        }
        this.setState({currentStep: initialStep, añoActual: año, loading: true, user: this.props.login.user_data})
        this.getAdminLites();
        Auth.currentSession()
            .then(session => {
                API.get(
                    'test',
                    '/taxes/planes',
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },

                    }
                )
                .then(response => {
                    let plans = response.filter(p => p.medio === 'MercadoPago').sort((a, b) => (a.costo > b.costo) ? 1 : -1);
                    let subPlans = response.filter(p => p.medio === 'MercadoPago' && p.plazo > 1).sort((a, b) => (a.costo > b.costo) ? 1 : -1);
                    let planSelectedInital = plans[0].planId
                    let aplicacionesMin = plans[1].costo
                    let aplicacionesIIBBMin = plans[2].costo
                    let plusMin = plans[0].costo
                    let premiumMin = plans[3].costo
                    this.setState({
                        costoPlus: parseInt(plusMin), //,parseInt(plusMin.costo / plusMin.plazo),
                        costoPremium: parseInt(premiumMin), //parseInt(premiumMin.costo / premiumMin.plazo),
                        costoAplicaciones: parseInt(aplicacionesMin), // parseInt(aplicacionesMin.costo / aplicacionesMin.plazo),
                        costoAplicaionesIIBB: parseInt(aplicacionesIIBBMin),
                        loading: false,
                        plans,
                        planSelected: planSelectedInital, subPlans

                    })

                })
                .catch(err => {
                    message.error("Error leyendo planes")
                    console.log(err)

                })
            })

    }

    updateData(field, value) {
        const data = this.state.payment_data
        data[field] = value
        this.setState({payment_data: data})
    }

    updateUser(field, value) {
        const data = this.state.user
        data[field] = value
        this.setState({user: data})
    }


    changePayment(field, value) {
        this.setState({medioPago: value})

    }

    prev() {
        let actualStep = this.state.currentStep
        switch (actualStep) {
            case 1:
                this.setState({currentStep: 0})
                break;
            case 2:
                this.props.form.resetFields(['tipo-plan'])
                this.setState({currentStep: 1, trabajaEnAplicacion: false})
                break;
            case 3:
                this.props.form.resetFields(['medio-pago'])
                this.setState({currentStep: 2, medioPago: 'Tarjeta'})
                break;
            default:
                this.setState({currentStep: this.state.currentStep - 1})
                break;
        }

    }


    next(value = 0) {
        let actualStep = this.state.currentStep

        switch (actualStep) {
            case 0:
                this.setState({currentStep: 1})
                break;

            case 1:
                const subPlans = this.state.subPlans.filter(p => p.plan == value)
                if (subPlans.length == 0) {
                    const plan = this.state.plans.find(p => p.plan == value)
                    this.tipoPlan = value
                    this.setState({planSelected: plan.planId, tipoPlan: value})
                    this.call_mercadopago(plan.planId)
                } else {
                    this.setState({currentStep: 2, tipoPlan: value, subPlans: subPlans})
                }
                break;

            case 2:
                this.setState({planSelected: value})
                this.call_mercadopago(value)
                break;

            default:
                break;
        }
    }

    call_mercadopago(planSelected) {
        let body = {}
        if (this.props.stepsUser === true) {
            body = {
                plan_id: planSelected,
                plan: this.tipoPlan,
                trabaja_aplicacion: this.state.trabajaEnAplicacion
            }
        } else {
            body = {
                plan_id: planSelected,
                plan: this.tipoPlan
            }
        }
        Auth.currentSession()
            .then(session => {
                API.put(
                    'test',
                    '/root/users/me/plan',
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },
                        body: body
                    }
                )
                .then(response => {
                    message.success("Plan actualizado correctamente")
                    let user = this.props.login.user_data
                    user['plan'] = this.state.tipoPlan
                    user['plan_id'] = this.state.planSelected
                    user['trabaja_aplicacion'] = this.state.trabajaEnAplicacion
                    this.props.UserDataLoad(user)
                    //this.props.history.push('/mercado-pago-mp/' + user['plan_id'])
                    this.props.history.push('/medio-pago-mp/' + user['plan_id'])
                })
                .catch(err => {
                    message.error("Hubo un error actualizando el plan")
                    this.props.history.push('/')
                    console.log(err)
                })
            })
    }

    adminLiteSelected = async (conCodigo = false) => {
        let user = this.props.login.user_data;
        const session = await Auth.currentSession();

        if (conCodigo) {
            const planId = this.state.plans.filter(p => p.plan === 'Codigo')[0].planId;
            const plan = 'Codigo'
            let body = {}
            if (this.props.stepsUser === true) {
                body = {
                    plan_id: planId,
                    plan: plan,
                    trabaja_aplicacion: this.state.trabajaEnAplicacion
                }
            } else {
                body = {
                    plan_id: planId,
                    plan: plan,
                }
            }

            user['plan'] = plan
            user['plan_id'] = planId;
            user['estado_pago'] = 'ACTIVO';
            this.props.UserDataLoad(user);

            try {
                const response = await API.put(
                    'test',
                    '/root/users/me/plan',
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },
                        body: body
                    }
                )
            } catch (e) {
                message.error("Hubo un error actualizando el plan")
                this.props.history.push('/')
                console.log(e)
            }

        }

        const [userCognito] = await Promise.all([
            Auth.currentUserInfo()
        ]);

        try {

            if(this.state.adminLiteSelected){

                await API.post(
                    'test',
                    '/root/admindashboard/relationship/user/create',
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },
                        body: {
                            adminCuit: this.state.adminLiteSelected.cuit,
                            userId: userCognito.username,
                            razonSocial: this.state.adminLiteSelected.razon_social,
                            domicilio: this.state.adminLiteSelected.domicilio,
                            tipoResponsable: this.state.adminLiteSelected.id_impositivo,
                            nombreUsuario: user.nombre,
                            apellidoUsuario: user.apellido,
                            emailUsuario: user.email,
                            telefonoUsuario: user.telefono,
                            cuitUsuario: null,
                            fecha_desde: moment().format('YYYY-MM-DD'),
                            fecha_hasta: null
                        }
                    }
                );
            }
        } catch (e) {
            message.error("Hubo un error cargarndo la relación laboral");
            console.error(e)
            return;
        }

        if (conCodigo) {
            this.props.history.push('/', {state: {data: {adminLite: this.state.adminLiteSelected}}})
        } else {
            this.setState({currentStep: 2})
        }
    }

    render() {
        if (this.state.loading) {
            return (
                <>
                    <Row></Row>
                    <Row type="flex" justify="space-around" align="middle" style={{marginTop: '150px'}}>
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                    <Row></Row>
                </>
            )
        }
        else {

            //const tipoPlan = this.state.plans.filter(planes => planes.plan === this.state.tipoPlan)
            //tipoPlan.sort((a, b) => (a.plazo > b.plazo) ? 1 : ((a.plazo < b.plazo) ? -1 : 0))
            //const plan = tipoPlan.filter(plan => plan.medio === this.state.medioPago)

            const {getFieldDecorator} = this.props.form;

            const noNullValidator = (rule, value, callback) => {
                if (value === undefined || value === null) {
                    callback("Seleccione una opcion")
                } else {
                    callback()
                }
            }

            const steps = [
                {
                    title: '',
                    icon: 'user',
                    content:
                        <>
                            <Paragraph className="ant-typography-stepsuser">Bienvenido a <b>Liqui!</b></Paragraph>
                            <Paragraph className="ant-typography-stepsuser">Antes de comenzar, necesitamos hacerte
                                algunas preguntas para conocer tu estado fiscal.
                                Solo te tomará 5 minutos.</Paragraph>
                            <Paragraph className="ant-typography-stepsuser"><b>Gracias por elegirnos!</b>
                            </Paragraph>
                        </>
                },
                {
                    title: 'Elegi tu plan',
                    content:
                        <>
                            <Form.Item>
                                {
                                    getFieldDecorator('plan', {
                                        rules: [
                                            {
                                                required: true
                                            }
                                        ],
                                        initialValue: null,
                                        value: this.state.planSelected
                                    })(
                                        <RadioGroup
                                            onChange={(e) => this.next(e.target.value)}
                                            buttonStyle='solid'
                                            style={{width: '100%'}}
                                        >
                                            <Row gutter={[50, 10]} type='flex' justify='center'>
                                                {/* {this.state.plans.map((plan) => 
                                                    <Col lg={10} xs={24}>
                                                        <TablePlan
                                                            title={plan.plan}
                                                            subtitle={"Pagás mensualmente $" + plan.costo}
                                                            color="#2c8eda"
                                                            price={plan.costo} //{this.state.medioPago === 'Tarjeta' ? parseInt(plan[0].costo / plan[0].plazo) : parseInt(plan[0].costo / plan[0].plazo)}
                                                            content={this.state.array}
                                                            button_value={plan.planId}
                                                        />
                                                    </Col>
                                                )} */}
                                                <Col lg={6} xs={24} style={{marginBottom: '5px', marginTop: '5px'}}>
                                                    <TablePlan
                                                        title={"Alta Monotributo"}
                                                        subtitle="30 Días gratis de Liqui"
                                                        color= "linear-gradient(to right, #49EBAC, #44C3B8)"
                                                        price={this.state.costoAplicaciones}
                                                        content={['Alta en Monotributo o II.BB', 'Alta Obra Social', '-', '-']}
                                                        button_value={"Alta Monotributo"}
                                                        discount="40% off"
                                                    />
                                                </Col>
                                                <Col lg={6} xs={24} style={{marginBottom: '5px', marginTop: '5px'}}>
                                                    <TablePlan
                                                        title={"Alta Mono + IIBB"}
                                                        subtitle="30 Días gratis de Liqui"
                                                        color= "linear-gradient(to right, #49EBAC, #44C3B8)"
                                                        price={this.state.costoAplicaionesIIBB}
                                                        content={['Alta en Monotributo', 'Alta Obra Social', 'Alta Ingresos Brutos', '-']}
                                                        button_value={"Alta Monotributo + IIBB"}
                                                        discount="20% off"
                                                    />
                                                </Col>
                                                <Col lg={6} xs={24} style={{marginBottom: '5px', marginTop: '5px'}}>
                                                    <TablePlan
                                                        title={"Plus"}
                                                        // subtitle="30 DÍAS GRATIS"
                                                        color= "linear-gradient(to right, #49EBAC, #44C3B8)"
                                                        price={this.state.costoPlus}
                                                        content={['Alta en Monotributo', 'Alta Obra Social', 'Alta Ingresos Brutos', 'Plataforma de impuestos']}
                                                        button_value={"Plus"}
                                                        subtitle="Por Mes"
                                                        discount="40% off"
                                                    />
                                                </Col>
                                                <Col lg={6} xs={24} style={{marginBottom: '5px', marginTop: '5px'}}>
                                                    <TablePlan
                                                        title={"Premium"}
                                                        //subtitle="30 DÍAS GRATIS"
                                                        color="linear-gradient(to right, #49EBAC, #44C3B8)"
                                                        price={this.state.costoPremium}
                                                        content={['Plan Plus', 'Liquidación Ingresos Brutos', 'Asesoramiento contable', '-']}
                                                        button_value={"Premium"}
                                                        subtitle="Por Mes"
                                                        discount="10% off"
                                                    />
                                                </Col>
                                            </Row>
                                        </RadioGroup>
                                    )
                                }
                            </Form.Item>
                        </>
                },
                {
                    title: '¿Cómo lo vas a pagar?',
                    content:
                        <>
                            <Form.Item>
                                {
                                    getFieldDecorator('plan', {
                                        rules: [
                                            {
                                                required: true
                                            }
                                        ],
                                        initialValue: null,
                                        value: this.state.planSelected
                                    })(
                                        <RadioGroup
                                            onChange={(e) => this.next(e.target.value)}
                                            buttonStyle='solid'
                                            style={{width: '100%'}}
                                        >
                                            <Row gutter={[50, 10]} type='flex' justify='center'>
                                                {this.state.subPlans.map((plan) => 
                                                    <Col key={plan.planId} span={6} lg={6} xs={6}>
                                                        <TablePlanCard
                                                            title={plan.plazo + ' Meses'}
                                                            price={parseInt(Math.round(plan.costo/plan.plazo))}
                                                            color="linear-gradient(to right, #49EBAC, #44C3B8)"
                                                            subtitle={"Pagás por única vez $" + parseInt(plan.costo)}
                                                            // content={this.state.array}
                                                            button_value={plan.planId}
                                                        />
                                                    </Col>
                                                )}
                                            </Row>
                                        </RadioGroup>
                                    )
                                }
                            </Form.Item>
                        </>
                }
            ];
            return (
                <>
                    {!this.props.stepsUser && <Card
                        title={
                            <Steps current={this.state.currentStep} style={{paddingLeft: '20%', paddingRight: '20%'}}>
                                {!this.props.stepsUser && steps.filter(stp => stp.title === '¿Cómo lo vas a pagar?' || stp.title === 'Elegí tu plan').map(item => (
                                    <Step key={item.title} title={item.title}/>
                                ))}
                            </Steps>
                        }
                        style={{marginBottom: 10, paddingRight: '10px', paddingLeft: '10px'}}
                        headStyle={{paddingRight: '5%', paddingLeft: '5%'}}
                    >

                        <Form hideRequiredMark>
                            <div className="steps-content">
                                {steps[this.state.currentStep].content}
                            </div>
                        </Form>
                    </Card>}

                    {this.props.stepsUser &&
                    <Form hideRequiredMark>
                        <Title level={2}
                               style={{marginBottom: "40px"}}><b>{steps[this.state.currentStep].title}</b>
                               </Title>
                        <div className="steps-content">
                            {steps[this.state.currentStep].content}
                        </div>
                    </Form>}

                    <div className="steps-action">
                        <center>
                            <Button.Group style={{marginTop: "5vh"}}>
                                {((this.props.stepsUser && this.state.currentStep > 0) || (!this.props.stepsUser && this.state.currentStep > 2)) && (
                                    <Button 
                                        className="ant-btn-stepsuser"
                                        type="primary" onClick={() => this.prev()}
                                        disabled={this.state.loading}>
                                        Anterior
                                    </Button>
                                )}
                                {(this.state.currentStep === 0) && (
                                    <Button 
                                        className="ant-btn-stepsuser"
                                        type="primary" 
                                        onClick={() => this.next()}>
                                        Continuar
                                    </Button>
                                )}
                            </Button.Group>
                        </center>
                    </div>
                </>
            );
        }
    }
}

const Plans = Form.create({nombre: 'plans'})(withBreakpoints(UpgradePlan));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Plans));
